'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE_IDS = exports.FILE_IDS = ['fileIds'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/fileAttachmentKeyPaths.js
// module id = 695
// module chunks = 2 3